"use client";

import { Splide, SplideSlide } from "@splidejs/react-splide";

import "@splidejs/splide/dist/css/splide-core.min.css";

import { ApplicationStep } from "@/components/molecules/ApplicationStep";
import { useTranslation } from "@/i18n/client";

interface ApplicationProcessProps {
  locale: string;
}

export const ApplicationProcess = ({ locale }: ApplicationProcessProps) => {
  const { t } = useTranslation(locale);
  const steps = [
    {
      title: t("application_process.step1.title"),
      description: t("application_process.step1.description"),
    },
    {
      title: t("application_process.step2.title"),
      description: t("application_process.step2.description"),
    },
    {
      title: t("application_process.step3.title"),
      description: t("application_process.step3.description"),
    },
  ];

  return (
    <>
      <h4 className="!mb-3 lg:!mb-10 lg:text-center">
        {t("job.process.title")}
      </h4>
      <div className="mb-6 text-black-300 lg:mb-24 lg:text-center">
        {t("job.process.description")}
      </div>
      {/* Desktop */}
      <div className="hidden grid-cols-3 gap-4 md:grid lg:gap-8">
        {steps.map((step, index) => {
          return (
            <SplideSlide key={index} className="pt-[30px]">
              <ApplicationStep
                description={step.description}
                number={index + 1}
                title={step.title}
                locale={locale}
              />
            </SplideSlide>
          );
        })}
      </div>

      {/* Mobile: carousel */}
      <div className="-mx-4 pl-4 md:hidden">
        <Splide
          options={{
            arrows: false,
            gap: "0.5rem",
            fixedWidth: "170px",
            perMove: 1,
            mediaQuery: "min",
            pagination: true,
            breakpoints: {
              768: {
                destroy: true,
              },
            },
            classes: {
              pagination: "splide__pagination !justify-start gap-2 !mt-6",
              page: "splide__pagination__page w-2 h-2 rounded-full bg-border",
            },
          }}
        >
          {steps.map((step, index) => {
            return (
              <SplideSlide key={index} className="pt-[30px]">
                <ApplicationStep
                  description={step.description}
                  number={index + 1}
                  title={step.title}
                />
              </SplideSlide>
            );
          })}
        </Splide>
      </div>
    </>
  );
};
